import { Tooltip } from 'antd';
import React, { FC, ReactNode } from 'react';
import { StyledStack } from '../Stack';
type StyledTagProps = {
  content: ReactNode;
  title?: ReactNode;
  bgColor?: string;
  textColor?: string;
  icon?: string;
  category?: string;
  colorTextTooltip?: string;
};

enum TagType {
  PROMOTION = 'promotion',
  TAG = 'tag',
}

const isWhiteShade = (color) => {
  const whiteShades = [
    '#FFFFFF',
    '#FFF',
    '#fff',
    '#ffffffff',
    '#ffffff',
    'rgb(255, 255, 255)',
    'rgba(255, 255, 255, 1)',
  ];
  return whiteShades.includes(color) ? "#7D7D7D" : color;
};

export const StyledTag: FC<StyledTagProps> = ({
  content,
  title,
  bgColor = '#E8E8E8',
  textColor = '#7D7D7D',
  icon,
  category,
}) => {
  if (!content) {
    return <></>
  }

  return (
    <Tooltip title={title}
      color="#fff"
      overlayInnerStyle={{
        color: '#ff7f3f',
        fontSize: '14px',
        fontWeight: 'bold',
        padding: '8px 12px',
        borderRadius: '6px',
        boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.15)',
      }}
    >
      <StyledStack
        style={{
          height: 28,
          width: 'fit-content',
          borderRadius: 30,
          color: isWhiteShade(textColor),
          background: bgColor,
          fontSize: 14,
          padding: '4px 10px',
          maxWidth: '45%',
          fontWeight: category === TagType.TAG ? 600 : 400,
        }}
        alignItem={'center'}
        columnGap={'5px'}
      >
        {icon && <img src={icon} alt="" height={'auto'} width={14} />}
        <div
          style={{
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            fontWeight: 600,
          }}
        >
          {content}
        </div>
      </StyledStack>
    </Tooltip>
  );
};
